import { Layout } from 'antd';
import { Outlet } from 'react-router';

import { useCheckOrientation } from '../../hooks/useCheckOrientation';
import { FooterComponent } from './footer';
import { HeaderComponent } from './header';
import { SideNav } from './sidebar';

export const MainLayout = () => {
  useCheckOrientation();

  return (
    <Layout>
      <SideNav />
      <Layout>
        <HeaderComponent />
        <Layout.Content className="layout-content layout-content-mobile">
          <Outlet />
        </Layout.Content>
        <FooterComponent />
      </Layout>
    </Layout>
  );
};
